export function isEmpty(str: string): boolean {
  return str.trim().length === 0;
}

export function escapeRegExp(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
